import React, { FC, useEffect, useState } from 'react';
import { updateCart } from './CartAction';
import { MontantOption } from './iCart';
import Modal from 'react-responsive-modal';
import { formatPrice, getShopRefInStorage } from '../mon-compte/MonCompteAction';

interface OptionCartProps {
  garantie: string;
  montantOptions: MontantOption;
  validerDroits: boolean;
  onValiderDroits?: (droits:boolean) => void;
}


export const RenderOptionsCart: FC<OptionCartProps> = ({ validerDroits, onValiderDroits, garantie, montantOptions }): JSX.Element => {
  const [openProtection, setOpenProtection] = useState<boolean>(false);
  const [openDroits, setOpenDroits] = useState<boolean>(false);
  const [validerDroitsState, setValiderDroitsState] = useState<boolean>(false);

  useEffect(() => {
    setValiderDroitsState(validerDroits);
  }, [validerDroits]);

  const stringToBoolean = (value: string|number): boolean => {
    return value == 1;
  };

  const updateOptionGarantie = (checked: boolean): void => {
    updateCart({ garantie: checked });
  };

  const handleChangeDroits = (checked: boolean): void => {
    setValiderDroitsState(checked);
    onValiderDroits?.(checked);
    if (checked) {
      document.getElementById('checkboxDroitsME')?.classList.remove('surbrillanceDroits');
    } else {
      document.getElementById('checkboxDroitsME')?.classList.add('surbrillanceDroits');
    }
  };

  return (
    <div className="mx-auto col-md-8 col-12 col-lg-8 p-0 pr-md-3 mb-3 mt-sm-2">
      {getShopRefInStorage()  === 'ME'  && (
        <>
          <div id="optionCart" className="px-2 border-left">
            <div className="d-flex align-items-center justify-content-start pl1">
              <input
                type="checkbox"
                onChange={event => updateOptionGarantie(event.target.checked)}
                checked={stringToBoolean(garantie)}
                id="checkboxGarantie"
                style={{ margin: '0' }}
              />
              <label htmlFor="checkboxGarantie" className="ma0">
                Protection totale
                <button
                  style={{
                    marginTop: '4px',
                    marginLeft: '10px',
                    marginRight: '10px',
                    marginBottom: '4px',
                    padding: '1px 7px',
                    borderRadius: '50%',
                    cursor: 'pointer'
                  }}
                  onClick={() => setOpenProtection(true)}
                >
                  ?
                </button>
              </label>
              <span className="priceOptions">
                &nbsp;{formatPrice(montantOptions.garantie_unitaire.toString())}  €<sup>ht</sup> / pièce
              </span>
            </div>
          </div>
          <div id="checkboxDroitsME" className="checkboxDroitsME">
            <input
              type="checkbox"
              name="valider"
              id="validerDroits"
              onChange={event => handleChangeDroits(event.target.checked)} checked={validerDroitsState}
              style={{ verticalAlign:'middle', margin:'0', marginRight:'5px', marginTop:'1px' }}
            />
            <label
              htmlFor="validerDroits"
              style={{ display:'inline', fontWeight:'normal', lineHeight:'1.5em', fontSize:'10px' }}
            >
              Je valide la mise en page du mug. J'atteste disposer des droits d'utilisation des visuels/éléments
              fournis et certifie qu'ils ne portent aucune atteinte aux droits de tiers quels qu'ils soient.
            </label>
            <button
              onClick={() => setOpenDroits(true)}
              style={{
                fontSize:'10px',
                textDecoration:'underline',
                background:'none',
                border:'none',
                cursor:'pointer'
              }}
              className="droits-images-colorbox"
            >
              Plus d'infos
            </button>
        </div>
        </>
      )}

      <Modal classNames={{ overlay: 'bootstrap-container' }} open={openProtection} onClose={() => setOpenProtection(false)} center>
        <div className="modalOrder p-2">
          <img src="/order/images/cart/protectionTotale.jpg" />
        </div>
      </Modal>

      <Modal open={openDroits} onClose={() => setOpenDroits(false)} center>
        <div className="modalOrder p-2">
          <div id="droits-images">
            <h1>Droits d'utilisation d'images</h1>
            <div>Droits des marques</div>
            <p>
              De nombreux logos/images sont protégés par copyright, si vous n'avez pas l'autorisation de leurs
              propriétaires, vous n'êtes pas en droit de les utiliser.
            </p>

            <div>Respect de la personne humaine</div>
            <p>
              Nous refusons de marquer un mug si il va à l'encontre du respect des personnes (diffamation,
              pornographie, atteinte aux bonnes mœurs, protection de l'enfance, incitation à la haine raciale et
              tout autre thème touchant au respect de la personne humaine).
            </p>
            <div>Droits des personnes</div>
            <p>
              Les photos de personnes célèbres ne peuvent pas être utilisées comme élément de marquage si vous
              n'avez pas leur permission.
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};
